import { Feature } from '@nirvana/shared/constants';
import { SubscriptionType } from '../../../../license/types/SubscriptionType';
import { ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';

// see Constants.Policies.SectionsEnabledByFeature from ExtJs
export const SectionsEnabledByFeature = {
  [Feature.PRODUCT_FEATURE_FRAT_VISIBLE]: [
    // general
    { moduleId: ModuleId.POLICY_SETTINGS, sectionId: SectionId.DETAILS },
    { moduleId: ModuleId.POLICY_SETTINGS, sectionId: SectionId.GENERAL_INHERITANCE },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.GENERAL_NOTIFICATIONS },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.COMMUNICATION },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.SETTINGS },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.UPDATE },
    // relay
    { moduleId: ModuleId.RELAY, sectionId: SectionId.COMMUNICATION },
    { moduleId: ModuleId.RELAY, sectionId: SectionId.UPDATE },
    // risk management
    { moduleId: ModuleId.INDICATORS_OF_RISK, sectionId: SectionId.NONE },
    // blocklist
    { moduleId: ModuleId.BLOCKLIST_RULES, sectionId: SectionId.NONE },
  ],
  [Feature.PRODUCT_FEATURE_COMPANION_STANDALONE]: [
    // general
    { moduleId: ModuleId.POLICY_SETTINGS, sectionId: SectionId.DETAILS },
    { moduleId: ModuleId.POLICY_SETTINGS, sectionId: SectionId.GENERAL_INHERITANCE },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.SETTINGS },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.COMMUNICATION },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.UPDATE },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.SECURITY_TELEMETRY },
    // antimalware
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.ANTIMALWARE_ON_EXECUTE },
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.SETTINGS },
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.EXCLUSIONS },
    // sandbox
    { moduleId: ModuleId.SANDBOX, sectionId: SectionId.ENDPOINT_SENSOR },
    { moduleId: ModuleId.SANDBOX, sectionId: SectionId.NETWORK_SENSOR }, // activable by sandbox license
    { moduleId: ModuleId.SANDBOX, sectionId: SectionId.SANDBOX_MANAGER }, // activable by sandbox license
    // network protection
    { moduleId: ModuleId.CONTENT_CONTROL, sectionId: SectionId.CONTENT_CONTROL_TRAFFIC },
    { moduleId: ModuleId.CONTENT_CONTROL, sectionId: SectionId.CONTENT_CONTROL_DATA_PROTECTION },
    { moduleId: ModuleId.CONTENT_CONTROL, sectionId: SectionId.CONTENT_CONTROL_NETWORK_MONITOR },
    // relay
    { moduleId: ModuleId.RELAY, sectionId: SectionId.COMMUNICATION },
    { moduleId: ModuleId.RELAY, sectionId: SectionId.UPDATE },
    // edr
    { moduleId: ModuleId.EDR_SENSOR, sectionId: SectionId.GENERAL },
    // risk management
    { moduleId: ModuleId.INDICATORS_OF_RISK, sectionId: SectionId.NONE },
    // live search
    { moduleId: ModuleId.LIVE_SEARCH, sectionId: SectionId.NONE },
    // blocklist
    { moduleId: ModuleId.BLOCKLIST_RULES, sectionId: SectionId.NONE },
  ],
};

// see Constants.Policies.SectionsEnabledBySubscription from ExtJs
export const SectionsEnabledBySubscription = {
  [SubscriptionType.Frat]: [
    // general
    { moduleId: ModuleId.POLICY_SETTINGS, sectionId: SectionId.DETAILS },
    { moduleId: ModuleId.POLICY_SETTINGS, sectionId: SectionId.GENERAL_INHERITANCE },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.GENERAL_NOTIFICATIONS },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.COMMUNICATION },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.SETTINGS },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.UPDATE },
    // relay
    { moduleId: ModuleId.RELAY, sectionId: SectionId.COMMUNICATION },
    { moduleId: ModuleId.RELAY, sectionId: SectionId.UPDATE },
    // risk management
    { moduleId: ModuleId.INDICATORS_OF_RISK, sectionId: SectionId.NONE },
  ],
  [SubscriptionType.BasicMonthly]: [
    // general
    { moduleId: ModuleId.POLICY_SETTINGS, sectionId: SectionId.DETAILS },
    { moduleId: ModuleId.POLICY_SETTINGS, sectionId: SectionId.GENERAL_INHERITANCE },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.GENERAL_NOTIFICATIONS },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.COMMUNICATION },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.SETTINGS },
    { moduleId: ModuleId.GENERAL, sectionId: SectionId.UPDATE },
    // antimalware
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.ANTIMALWARE_ON_ACCESS },
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.ANTIMALWARE_ON_EXECUTE },
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.ANTIMALWARE_ON_DEMAND },
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.ANTIMALWARE_DYNAMIC_THREAT_DEFENSE },
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.ANTIMALWARE_ANTI_EXPLOIT },
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.SETTINGS },
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.EXCLUSIONS },
    { moduleId: ModuleId.ANTIMALWARE, sectionId: SectionId.ANTIMALWARE_SECURITY_SERVERS },
    // network protection
    { moduleId: ModuleId.CONTENT_CONTROL, sectionId: SectionId.CONTENT_CONTROL_TRAFFIC },
    { moduleId: ModuleId.CONTENT_CONTROL, sectionId: SectionId.CONTENT_CONTROL_WEB },
    { moduleId: ModuleId.CONTENT_CONTROL, sectionId: SectionId.CONTENT_CONTROL_DATA_PROTECTION },
    { moduleId: ModuleId.CONTENT_CONTROL, sectionId: SectionId.CONTENT_CONTROL_NETWORK_MONITOR },
    // relay
    { moduleId: ModuleId.RELAY, sectionId: SectionId.COMMUNICATION },
    { moduleId: ModuleId.RELAY, sectionId: SectionId.UPDATE },
    // blocklist
    { moduleId: ModuleId.BLOCKLIST_RULES, sectionId: SectionId.NONE },
  ],
};
